import React from 'react'

const Question = () => {
  return (
    <>
      <section className='p-8 space-y-5 lg:space-y-9 bg-gray-100'>
        <h1 className='text-center text-xl text-gray-600 p-2'>Frequently Asked Questions</h1>
        <div className='py-1 space-y-3 max-w-5xl mx-auto '>
            <h2 className='text-lg text-gray-500'>How will B.Tech Companion be helpful for me?</h2>
            <p className='text-md '>B.Tech Companion gives you 360-degree guidance in your preparation, counselling and admission process through College Predictors (which predict admission chances based on your rank, category, counselling, location and more), 3 Full-Length JEE-Main Mock Tests, a printed Almanac (with 1000+ FAQs on preparation, admissions, top colleges etc), Webinar Sessions and Regular updates and notifications regarding B.Tech admissions.</p>
        </div>
        <div className='py-1 space-y-3 max-w-5xl mx-auto'>
            <h2 className='text-lg text-gray-500'>What College Predictors are covered in B.Tech Companion?</h2>
            <p className='text-md '>B.Tech Companion gives you 360-degree guidance in your preparation, counselling and admission process through College Predictors (which predict admission chances based on your rank, category, counselling, location and more), 3 Full-Length JEE-Main Mock Tests, a printed Almanac (with 1000+ FAQs on preparation, admissions, top colleges etc), Webinar Sessions and Regular updates and notifications regarding B.Tech admissions.</p>
        </div>
        <div className='py-1 space-y-3 max-w-5xl mx-auto'>
            <h2 className='text-lg text-gray-500'>How and when shall I access the Companion?</h2>
            <p className='text-md '>Once you purchase the companion, you will get direct access to all the college predictors in the companion. We will notify you for all the updates via emails and SMS. You will also get exclusive access to our Webinars via email. The Almanac will be delivered to your doorstep.</p>
        </div>
      </section>
    </>
  )
}

export default Question
